import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Dragon = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/sushi' name='Дракони'/>
            <main className={s.main}>
                <Product name='Зелений дракон' price='220 грн.' weight='310г./8шт.' info1='рис, норі, філаделфія, вугор, огірок, авокадо, унарі, кунжут'/>
                <Product name='Золотий дракон' price='250 грн.' weight='310г./8шт.' info1='рис, норі, філаделфія, вугор, лосось, огірок, унарі, кунжут'/>
                <Product name='Чорний дракон' price='230 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, груша, авокадо, вугор, огірок, унарі, кунжут чорний'/>
                <Product name='Білий дракон' price='220 грн.' weight='280г./8шт.' info1='рис, норі, філаделфія, лосось, ківі, кокосова стружка'/>
                <Product name='Червоний дракон' price='220 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, крабова паличка, авокадо, лосось'/>
                <Product name='Жовтий дракон' price='210 грн.' weight='300г./8шт.' info1='рис, норі, філаделфія, лосось, авокадо, сир тостовий, соус сирний, пармезан'/>
                <Product name='Сніжний дракон' price='230 грн.' weight='290г./8шт.' info1='рис, норі, філаделфія, ківі, вугор, унарі, кокосова стружка'/>
            </main>
        </div>
    )
}

export default Dragon;